import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './CheckBox.scss';
import classNames from 'classnames';
import RcCheckBox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';

export default class CheckBox extends Component {
    static propTypes = {
        prefixLabel: PropTypes.string,
        label: PropTypes.string,
        containerClassName: PropTypes.string,
        className: PropTypes.string,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired
    };

    render() {
        const {
            prefixLabel,
            label,
            checked,
            disabled,
            className,
            containerClassName
        } = this.props;

        const onChange = disabled ? _.noop : this.props.onChange;

        const checkBoxClassName = classNames(className, {
           [styles.checkBoxDisabled]: disabled
        });

        return (
            <label className={containerClassName}>
                {prefixLabel} &nbsp;
                <RcCheckBox className={checkBoxClassName}
                            checked={checked}
                            onChange={onChange}/>
                &nbsp; {label}
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/CheckBox.jsx